import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Breadcrumb from "@/components/common/Breadcrumb";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ArrowLeft } from "lucide-react";

export default function TaskSettingsPage() {
  const navigate = useNavigate();
  const [defaultView, setDefaultView] = useState<string>("list");
  const [showCompletedTasks, setShowCompletedTasks] = useState<boolean>(true);
  const [defaultSort, setDefaultSort] = useState<string>("due_date");
  const [emailNotifications, setEmailNotifications] = useState<boolean>(true);
  const [pushNotifications, setPushNotifications] = useState<boolean>(true);
  
  const handleSave = () => {
    // Aqui seria implementada a lógica para salvar as configurações
    navigate("/task-management");
  };
  
  return (
    <div className="container mx-auto py-6 space-y-6">
        {/* Breadcrumb */}
        <div className="mb-4">
          <Breadcrumb 
            items={[
              { label: "Dashboard", href: "/" },
              { label: "Minhas Atividades", href: "/task-management" },
              { label: "Configurações" }
            ]} 
          />
        </div>
        
        <div className="flex items-center gap-4 mb-6">
          <Button 
            variant="ghost" 
            size="icon" 
            onClick={() => navigate("/task-management")}
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div>
            <h1 className="text-2xl font-extrabold">Configurações</h1>
            <p className="text-muted-foreground">
              Personalize suas preferências de tarefas
            </p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card>
            <CardHeader>
              <CardTitle>Visualização</CardTitle>
              <CardDescription>
                Configure como suas tarefas são exibidas
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="default-view">Visualização padrão</Label>
                <Select value={defaultView} onValueChange={setDefaultView}>
                  <SelectTrigger id="default-view">
                    <SelectValue placeholder="Selecione a visualização padrão" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="list">Lista</SelectItem>
                    <SelectItem value="kanban">Kanban</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="default-sort">Ordenação padrão</Label>
                <Select value={defaultSort} onValueChange={setDefaultSort}>
                  <SelectTrigger id="default-sort">
                    <SelectValue placeholder="Selecione a ordenação padrão" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="due_date">Data de vencimento</SelectItem>
                    <SelectItem value="priority">Prioridade</SelectItem>
                    <SelectItem value="created_at">Data de criação</SelectItem>
                    <SelectItem value="title">Título</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              
              <div className="flex items-center space-x-2">
                <Switch
                  id="show-completed"
                  checked={showCompletedTasks}
                  onCheckedChange={setShowCompletedTasks}
                />
                <Label htmlFor="show-completed">Mostrar tarefas concluídas</Label>
              </div>
            </CardContent>
          </Card>
          
          <Card>
            <CardHeader>
              <CardTitle>Notificações</CardTitle>
              <CardDescription>
                Configure como você recebe notificações sobre suas tarefas
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex items-center space-x-2">
                <Switch
                  id="email-notifications"
                  checked={emailNotifications}
                  onCheckedChange={setEmailNotifications}
                />
                <Label htmlFor="email-notifications">Notificações por email</Label>
              </div>
              
              <div className="flex items-center space-x-2">
                <Switch
                  id="push-notifications"
                  checked={pushNotifications}
                  onCheckedChange={setPushNotifications}
                />
                <Label htmlFor="push-notifications">Notificações push</Label>
              </div>
            </CardContent>
          </Card>
        </div>
        
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => navigate("/task-management")}>
            Cancelar
          </Button>
          <Button onClick={handleSave}>
            Salvar configurações
          </Button>
        </div>
      </div>
  );
} 